import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';

export default (function (id) {
  const { exec, isRequestSuccessed, rst } = useRequest({
    url: '',
    name: 'DELETE_PRODUCTION_MOLD',
    method: 'DELETE',
  });

  useEffect(() => {
    if (id) {
      exec({
        url: `/api/product_mold_relation/${id}`,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return [rst, isRequestSuccessed];
});
